import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

// Reusable role→member crew dropdown list. The single source of truth for the
// team-assignment UI, shared by EditBookingModal and the manifest detail sheet.
//  - teamAssignments: [{ teamId, roleIds, roleId, roleName }]
//  - getTeamWithStatus(roleIds): members annotated with { available, reason }
//  - onTeamChange(idx, memberIdOr'unassigned')
export const TeamAssignmentSelector = ({
  teamAssignments = [],
  roles = [],
  getTeamWithStatus,
  onTeamChange,
  disabled = false,
  testIdPrefix = 'team-assign',
  triggerClassName = '',
}) => {
  if (!teamAssignments || teamAssignments.length === 0) return null;
  return (
    <div className="space-y-2" data-testid={`${testIdPrefix}-list`}>
      {teamAssignments.map((assignment, idx) => {
        const assignRoleIds = assignment.roleIds || (assignment.roleId ? [assignment.roleId] : []);
        const teamWithStatus = getTeamWithStatus(assignRoleIds);
        const displayRoleName =
          assignment.roleName ||
          assignRoleIds.map((id) => roles.find((r) => r.id === id)?.name).filter(Boolean).join(' or ') ||
          'Team Member';
        const primaryRole = roles.find((r) => r.id === assignRoleIds[0]);
        const roleColor = primaryRole?.color || '#6B7280';

        return (
          <div key={`team-${idx}`} className="flex items-center gap-2" data-testid={`${testIdPrefix}-row-${idx}`}>
            <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: roleColor }} />
            <span className="text-xs text-gray-600 w-24 truncate" title={displayRoleName}>
              {displayRoleName}
            </span>
            <Select
              value={assignment.teamId || 'unassigned'}
              onValueChange={(value) => onTeamChange(idx, value)}
              disabled={disabled}
            >
              <SelectTrigger className={`flex-1 h-9 text-sm ${triggerClassName}`} data-testid={`${testIdPrefix}-select-${idx}`}>
                <SelectValue placeholder="Select" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="unassigned" data-testid={`${testIdPrefix}-option-${idx}-unassigned`}>— Unassigned —</SelectItem>
                {teamWithStatus.map((member) => (
                  <SelectItem
                    key={member.id}
                    value={member.id}
                    disabled={!member.available}
                    data-testid={`${testIdPrefix}-option-${idx}-${member.id}`}
                  >
                    <span className={!member.available ? 'text-gray-400' : ''}>
                      {member.name} {!member.available && `(${member.reason})`}
                    </span>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        );
      })}
    </div>
  );
};

export default TeamAssignmentSelector;
